import { AuthenticatedLayout } from "../../../layouts/AuthenticatedLayout/AuthenticatedLayout";
import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import { FC } from "react";
import { TaxSlipDefinitionsList } from "../../../components/TaxSlipCategory/TaxSlipDefinitionsList";

export interface ITaxSlipDefinitionsListPage {}

export const TaxSlipDefinitionsListPage: FC<ITaxSlipDefinitionsListPage> = () => {
  return (
    <AuthenticatedLayout
      pageTitle="TaxSlip Definitions"
      pageTitleIcon={<DescriptionOutlinedIcon />}
      breadcrumbCurrentPageName=""
      breadcrumbLinks={[{text: 'TaxSlip Definitions', navigateTo: '/taxslip-definitions/list'}]}
      mainContents={<TaxSlipDefinitionsList />}
    />
  );
};
